var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column-wrapper"},[_c('goods-list',{attrs:{"sku-list":_vm.columnList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }